var styles = {"box":"Logo_box_1xmyc_1","sm":"Logo_sm_1xmyc_41","logo":"Logo_logo_1xmyc_46","logo-image":"Logo_logo-image_1xmyc_51","coming-soon":"Logo_coming-soon_1xmyc_65","mask-small":"Logo_mask-small_1xmyc_75","mask-bottom":"Logo_mask-bottom_1xmyc_82"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
